import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const Footer: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleClickJump = (item: string) => {
    if (item === "Home") {
      navigate("/");
    } else {
      navigate(`/${item.toLocaleLowerCase()}`);
    }
  };

  return (
    <>
      <div className="w-full flex justify-center pt-12 pb-8 bg-[#f6f7f8]">
        <div className="w-full max-w-[1116px] px-8 flex flex-col items-center">
          <div
            className={`w-full ${
              windowWidth > 800
                ? "flex justify-between"
                : "flex flex-col gap-y-4"
            }`}
          >
            <div
              className={`flex flex-col ${
                windowWidth > 800 ? "w-[24%]" : "w-full"
              }`}
            >
              <div className="mb-8  border-b-[1px]">
                <h5
                  className={`font-semibold pt-2 pb-2 tracking-widest ${
                    windowWidth > 800 ? "text-xs" : "text-sm"
                  }`}
                >
                  私について
                </h5>
                <span className="block w-14 h-[3px] bg-black"></span>
              </div>
              {/* <p className="text-sm">{process.env.REACT_APP_DESCRIPTION}</p> */}
              <p className="text-sm">
                アジア大陸の多様な文化、雄大な風景、豊かな歴史を発見するための究極のガイド、Explore
                Asiaへようこそ。東京の賑やかな街からバリの穏やかなビーチまで、当ウェブサイトでは、洞察に富んだ記事、旅行のヒント、そしてあなたの次のアジアでの冒険を刺激する素晴らしいビジュアルを提供しています。
              </p>
            </div>
            <div
              className={`flex flex-col ${
                windowWidth > 800 ? "w-[15%]" : "w-full"
              }`}
            >
              <div className="mb-8 border-b-[1px]">
                <h5
                  className={`font-semibold pt-2 pb-2 tracking-widest ${
                    windowWidth > 800 ? "text-xs" : "text-sm"
                  }`}
                >
                  クイックリンク
                </h5>
                <span className="block w-14 h-[3px] bg-black"></span>
              </div>
              <ul className="flex flex-col text-xs font-medium text-gray-600">
                {["ホーム", "旅行", "ガイド", "食事", "ホテル"].map(
                  (item, index) => (
                    <li
                      key={index}
                      className={`flex border-b-[1px] border-dotted border-[#d1d2d3] py-2.5 cursor-pointer last-of-type:border-b-0
                           ${
                             location.pathname === item.toLocaleLowerCase()
                               ? "text-[#5b68d3]"
                               : "hover:text-[#5b68d3]"
                           }`}
                      onClick={() => handleClickJump(item)}
                    >
                      <span>{item}</span>
                    </li>
                  )
                )}
              </ul>
            </div>
            <div
              className={`flex flex-col ${
                windowWidth > 800 ? "w-[22%] " : "w-full"
              }`}
            >
              <div className="mb-8  border-b-[1px]">
                <h5
                  className={`font-semibold pt-2 pb-2 tracking-widest ${
                    windowWidth > 800 ? "text-xs " : "text-sm"
                  }`}
                >
                  タグクラウド
                </h5>
                <span className="block w-14 h-[3px] bg-black"></span>
              </div>
              <ul className="flex flex-wrap text-xs font-medium text-gray-600">
                {[
                  "文化的な滞在",
                  "生活ガイド",
                  "祭りの食事",
                  "季節の風景",
                  "熱帯の休暇",
                  // "Tea mastery",
                  // "Puppet theatre",
                ].map((item, index) => (
                  <li
                    key={index}
                    className="flex border-[1px] px-5 py-2 bg-[#f0f1f3] rounded-full mr-2 mb-3 hover:text-[#5b68d3]"
                  >
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
            <div
              className={`flex flex-col ${
                windowWidth > 800 ? "w-[31%]" : "w-full"
              }`}
            >
              <div className="mb-8  border-b-[1px]">
                <h5
                  className={`font-semibold pt-2 pb-2 tracking-widest ${
                    windowWidth > 800 ? "text-xs " : "text-sm"
                  }`}
                >
                  ニュースレター
                </h5>
                <span className="block w-14 h-[3px] bg-black"></span>
              </div>
              <p className="text-sm line-clamp-3">
                ニュースレターに登録して、最新の更新情報をあなたのインボックスで受け取ろう。
              </p>
              <form className="mt-8 flex flex-col">
                <div className="flex items-center mb-5">
                  <input
                    className="w-[62%] py-3 px-4 placeholder:text-[#909090] border-[1px] border-r-0 border-[#dddddd] rounded-full rounded-r-none focus:outline-none"
                    type="text"
                    placeholder="メールアドレスを入力"
                  />
                  <button className="w-[38%] py-3 border-[1px] border-l-0 border-[#dddddd] rounded-full rounded-l-none bg-[#5b68d3] hover:bg-[#3a47ab] text-white text-base font-bold">
                    登録する
                  </button>
                </div>
                <label>
                  <input type="checkbox" />
                  <span className="text-sm ml-2">
                    <b className="text-[#646f80] cursor-pointer font-medium hover:text-[#5b68d3]">
                      利用規約に同意します
                    </b>
                  </span>
                </label>
              </form>
            </div>
          </div>
          <div
            className={`w-full flex pt-8 mt-8 border-t-[1px] text-xs text-[#5c687a]${
              windowWidth > 950
                ? " justify-between space-x-2"
                : " flex-col space-y-2"
            }`}
          >
            <span>
              © 2020, Stories - Personal Blog HTML Template ⇒ © 2025 Puffygame.
              アジアに関するすべての情報がここにあります。
            </span>
            <span>
              全著作権所有。 |{" "}
              <b
                className="text-blue-600 cursor-pointer hover:underline"
                onClick={() => (window.location.href = "/privacy")}
              >
                プライバシーポリシー
              </b>
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
